module.exports = __webpack_public_path__ + "img/company-seal.8ec7f726.png";